<template>
  <div class="menu_section" v-if="show">
    <h3 v-if="label">{{ label }}</h3>
    <sidebar-menu>
      <slot>
        <template v-for="menuItem in menuItems">
          <sidebar-menu-item ref="menuItems" :data="menuItem"/>
        </template>
      </slot>
    </sidebar-menu>
  </div>
</template>

<script>

import SidebarMenu from "@/components/layout/SideBar/SidebarMenu";
import SidebarMenuItem from "@/components/layout/SideBar/SidebarMenuItem";
import checkMountedMixins from "@/mixins/checkMountedMixins";

export default {
  name: "MenuSection",
  mixins:[
    checkMountedMixins
  ],
  components: {
    SidebarMenu,
    SidebarMenuItem,
  },
  props: {
    label: String,
    menuItems: Array
  },
  computed:{
    show() {
      let show = true;
      if (this.isMounted) {
        show = show && this.$refs.menuItems.some(x => x.isShow());
      }
      return show;
    },
  }
}
</script>

<style scoped>

</style>